import './styles.scss'

import React from 'react'
import ReactHtmlParser from 'react-html-parser'
import PropTypes from 'prop-types'

import I18n from 'lib/i18n'

const AllCities = ({ allCities }) => {
  return (
    <div className='grid grid-full small-wide cities'>
      <div className='col-1-1'>
        <span className='list-header'>{ReactHtmlParser(I18n.t('layouts.footer.cities_list_title'))}</span>
        <span className='list cities-list'>
          {allCities.map((city, index) => (
            <a href={city.url} key={index}>
              {city.title}
            </a>
          ))}
        </span>
      </div>
    </div>
  )
}

AllCities.propTypes = {
  allCities: PropTypes.array
}

export default AllCities
